module.exports = __webpack_public_path__ + "img/location-orange.d93ced6b.svg";